import React, {ReactElement} from 'react';

interface Currency {
    code: string,
    name: string,
    symbol: string,
    reactComponent: ReactElement
}

export const currencies: Currency[] = [
    {
        code: "EUR",
        name: "Euro",
        symbol: "&#8364;",
        reactComponent: <>&#8364;</>
    },
    {
        code: "USD",
        name: "United States dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "AED",
        name: "United Arab Emirates dirham",
        symbol: "&#1583;.&#1573;",
        reactComponent: <>&#1583;.&#1573;</>
    },
    {
        code: "AFN",
        name: "Afghan afghani",
        symbol: "&#65;&#102;",
        reactComponent: <>&#65;&#102;</>
    },
    {
        code: "ALL",
        name: "Albanian lek",
        symbol: "&#76;&#101;&#107;",
        reactComponent: <>&#76;&#101;&#107;</>
    },
    {
        code: "AMD",
        name: "Armenian dram",
        symbol: "AMD",
        reactComponent: <>AMD</>
    },
    {
        code: "AOA",
        name: "Angolan kwanza",
        symbol: "&#75;&#122;",
        reactComponent: <>&#75;&#122;</>
    },
    {
        code: "ARS",
        name: "Argentine peso",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "AUD",
        name: "Australian dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "AWG",
        name: "Aruban florin",
        symbol: "&#402;",
        reactComponent: <>&#402;</>
    },
    {
        code: "AZN",
        name: "Azerbaijani manat",
        symbol: "&#1084;&#1072;&#1085;",
        reactComponent: <>&#1084;&#1072;&#1085;</>
    },
    {
        code: "BAM",
        name: "Bosnia and Herzegovina convertible mark",
        symbol: "&#75;&#77;",
        reactComponent: <>&#75;&#77;</>
    },
    {
        code: "BBD",
        name: "Barbadian dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "BDT",
        name: "Bangladeshi taka",
        symbol: "&#2547;",
        reactComponent: <>&#2547;</>
    },
    {
        code: "BGN",
        name: "Bulgarian lev",
        symbol: "&#1083;&#1074;",
        reactComponent: <>&#1083;&#1074;</>
    },
    {
        code: "BHD",
        name: "Bahraini dinar",
        symbol: ".&#1583;.&#1576;",
        reactComponent: <>.&#1583;.&#1576;</>
    },
    {
        code: "BIF",
        name: "Burundian franc",
        symbol: "&#70;&#66;&#117;",
        reactComponent: <>&#70;&#66;&#117;</>
    },
    {
        code: "BMD",
        name: "Bermudian dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "BND",
        name: "Brunei dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "BOB",
        name: "Bolivian boliviano",
        symbol: "&#36;&#98;",
        reactComponent: <>&#36;&#98;</>
    },
    {
        code: "BRL",
        name: "Brazilian real",
        symbol: "&#82;&#36;",
        reactComponent: <>&#82;&#36;</>
    },
    {
        code: "BSD",
        name: "Bahamian dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "BTN",
        name: "Bhutanese ngultrum",
        symbol: "&#78;&#117;&#46;",
        reactComponent: <>&#78;&#117;&#46;</>
    },
    {
        code: "BWP",
        name: "Botswana pula",
        symbol: "&#80;",
        reactComponent: <>&#80;</>
    },
    {
        code: "BYR",
        name: "Belarusian ruble",
        symbol: "&#112;&#46;",
        reactComponent: <>&#112;&#46;</>
    },
    {
        code: "BZD",
        name: "Belize dollar",
        symbol: "&#66;&#90;&#36;",
        reactComponent: <>&#66;&#90;&#36;</>
    },
    {
        code: "CAD",
        name: "Canadian dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "CDF",
        name: "Congolese franc",
        symbol: "&#70;&#67;",
        reactComponent: <>&#70;&#67;</>
    },
    {
        code: "CHF",
        name: "Swiss franc",
        symbol: "&#67;&#72;&#70;",
        reactComponent: <>&#67;&#72;&#70;</>
    },
    {
        code: "CLP",
        name: "Chilean peso",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "CNY",
        name: "Chinese yuan",
        symbol: "&#165;",
        reactComponent: <>&#165;</>
    },
    {
        code: "COP",
        name: "Colombian peso",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "CRC",
        name: "Costa Rican colón",
        symbol: "&#8353;",
        reactComponent: <>&#8353;</>
    },
    {
        code: "CUP",
        name: "Cuban convertible peso",
        symbol: "CUC$",
        reactComponent: <>CUC$</>
    },
    {
        code: "CVE",
        name: "Cape Verdean escudo",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "CZK",
        name: "Czech koruna",
        symbol: "&#75;&#269;",
        reactComponent: <>&#75;&#269;</>
    },
    {
        code: "DJF",
        name: "Djiboutian franc",
        symbol: "&#70;&#100;&#106;",
        reactComponent: <>&#70;&#100;&#106;</>
    },
    {
        code: "DKK",
        name: "Danish krone",
        symbol: "&#107;&#114;",
        reactComponent: <>&#107;&#114;</>
    },
    {
        code: "DOP",
        name: "Dominican peso",
        symbol: "&#82;&#68;&#36;",
        reactComponent: <>&#82;&#68;&#36;</>
    },
    {
        code: "DZD",
        name: "Algerian dinar",
        symbol: "&#1583;&#1580;",
        reactComponent: <>&#1583;&#1580;</>
    },
    {
        code: "EGP",
        name: "Egyptian pound",
        symbol: "&#163;",
        reactComponent: <>&#163;</>
    },
    {
        code: "ERN",
        name: "Eritrean nakfa",
        symbol: "ERN",
        reactComponent: <>ERN</>
    },
    {
        code: "ETB",
        name: "Ethiopian birr",
        symbol: "&#66;&#114;",
        reactComponent: <>&#66;&#114;</>
    },
    {
        code: "FJD",
        name: "Fijian dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "FKP",
        name: "Falkland Islands pound",
        symbol: "&#163;",
        reactComponent: <>&#163;</>
    },
    {
        code: "GBP",
        name: "British pound",
        symbol: "&#163;",
        reactComponent: <>&#163;</>
    },
    {
        code: "GEL",
        name: "Georgian lari",
        symbol: "&#4314;",
        reactComponent: <>&#4314;</>
    },
    {
        code: "GHS",
        name: "Ghana cedi",
        symbol: "&#162;",
        reactComponent: <>&#162;</>
    },
    {
        code: "GMD",
        name: "Gambian dalasi",
        symbol: "&#68;",
        reactComponent: <>&#68;</>
    },
    {
        code: "GNF",
        name: "Guinean franc",
        symbol: "&#70;&#71;",
        reactComponent: <>&#70;&#71;</>
    },
    {
        code: "GTQ",
        name: "Guatemalan quetzal",
        symbol: "&#81;",
        reactComponent: <>&#81;</>
    },
    {
        code: "GYD",
        name: "Guyanese dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "HKD",
        name: "Hong Kong dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "HNL",
        name: "Honduran lempira",
        symbol: "&#76;",
        reactComponent: <>&#76;</>
    },
    {
        code: "HRK",
        name: "Croatian kuna",
        symbol: "&#107;&#110;",
        reactComponent: <>&#107;&#110;</>
    },
    {
        code: "HTG",
        name: "Haitian gourde",
        symbol: "&#71;",
        reactComponent: <>&#71;</>
    },
    {
        code: "HUF",
        name: "Hungarian forint",
        symbol: "&#70;&#116;",
        reactComponent: <>&#70;&#116;</>
    },
    {
        code: "IDR",
        name: "Indonesian rupiah",
        symbol: "&#82;&#112;",
        reactComponent: <>&#82;&#112;</>
    },
    {
        code: "ILS",
        name: "Israeli new shekel",
        symbol: "&#8362;",
        reactComponent: <>&#8362;</>
    },
    {
        code: "IMP",
        name: "Manx pound",
        symbol: "IMP",
        reactComponent: <>IMP</>
    },
    {
        code: "INR",
        name: "Indian rupee",
        symbol: "&#8377;",
        reactComponent: <>&#8377;</>
    },
    {
        code: "IQD",
        name: "Iraqi dinar",
        symbol: "&#1593;.&#1583;",
        reactComponent: <>&#1593;.&#1583;</>
    },
    {
        code: "IRR",
        name: "Iranian rial",
        symbol: "&#65020;",
        reactComponent: <>&#65020;</>
    },
    {
        code: "ISK",
        name: "Icelandic króna",
        symbol: "&#107;&#114;",
        reactComponent: <>&#107;&#114;</>
    },
    {
        code: "JEP",
        name: "Jersey pound",
        symbol: "&#163;",
        reactComponent: <>&#163;</>
    },
    {
        code: "JMD",
        name: "Jamaican dollar",
        symbol: "&#74;&#36;",
        reactComponent: <>&#74;&#36;</>
    },
    {
        code: "JOD",
        name: "Jordanian dinar",
        symbol: "&#74;&#68;",
        reactComponent: <>&#74;&#68;</>
    },
    {
        code: "JPY",
        name: "Japanese yen",
        symbol: "&#165;",
        reactComponent: <>&#165;</>
    },
    {
        code: "KES",
        name: "Kenyan shilling",
        symbol: "&#75;&#83;&#104;",
        reactComponent: <>&#75;&#83;&#104;</>
    },
    {
        code: "KGS",
        name: "Kyrgyzstani som",
        symbol: "&#1083;&#1074;",
        reactComponent: <>&#1083;&#1074;</>
    },
    {
        code: "KHR",
        name: "Cambodian riel",
        symbol: "&#6107;",
        reactComponent: <>&#6107;</>
    },
    {
        code: "KMF",
        name: "Comorian franc",
        symbol: "&#67;&#70;",
        reactComponent: <>&#67;&#70;</>
    },
    {
        code: "KPW",
        name: "North Korean won",
        symbol: "&#8361;",
        reactComponent: <>&#8361;</>
    },
    {
        code: "KRW",
        name: "South Korean won",
        symbol: "&#8361;",
        reactComponent: <>&#8361;</>
    },
    {
        code: "KWD",
        name: "Kuwaiti dinar",
        symbol: "&#1583;.&#1603;",
        reactComponent: <>&#1583;.&#1603;</>
    },
    {
        code: "KYD",
        name: "Cayman Islands dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "KZT",
        name: "Kazakhstani tenge",
        symbol: "&#1083;&#1074;",
        reactComponent: <>&#1083;&#1074;</>
    },
    {
        code: "LAK",
        name: "Lao kip",
        symbol: "&#8365;",
        reactComponent: <>&#8365;</>
    },
    {
        code: "LBP",
        name: "Lebanese pound",
        symbol: "&#163;",
        reactComponent: <>&#163;</>
    },
    {
        code: "LKR",
        name: "Sri Lankan rupee",
        symbol: "&#8360;",
        reactComponent: <>&#8360;</>
    },
    {
        code: "LRD",
        name: "Liberian dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "LSL",
        name: "Lesotho loti",
        symbol: "&#76;",
        reactComponent: <>&#76;</>
    },
    {
        code: "LTL",
        name: "Lithuanian litas",
        symbol: "&#76;&#116;",
        reactComponent: <>&#76;&#116;</>
    },
    {
        code: "LVL",
        name: "Latvian lats",
        symbol: "&#76;&#115;",
        reactComponent: <>&#76;&#115;</>
    },
    {
        code: "LYD",
        name: "Libyan dinar",
        symbol: "&#1604;.&#1583;",
        reactComponent: <>&#1604;.&#1583;</>
    },
    {
        code: "MAD",
        name: "Moroccan dirham",
        symbol: "&#1583;.&#1605;.",
        reactComponent: <>&#1583;.&#1605;.</>
    },
    {
        code: "MDL",
        name: "Moldovan leu",
        symbol: "&#76;",
        reactComponent: <>&#76;</>
    },
    {
        code: "MGA",
        name: "Malagasy ariary",
        symbol: "&#65;&#114;",
        reactComponent: <>&#65;&#114;</>
    },
    {
        code: "MKD",
        name: "Macedonian denar",
        symbol: "&#1076;&#1077;&#1085;",
        reactComponent: <>&#1076;&#1077;&#1085;</>
    },
    {
        code: "MMK",
        name: "Burmese kyat",
        symbol: "&#75;",
        reactComponent: <>&#75;</>
    },
    {
        code: "MNT",
        name: "Mongolian tögrög",
        symbol: "&#8366;",
        reactComponent: <>&#8366;</>
    },
    {
        code: "MOP",
        name: "Macanese pataca",
        symbol: "&#77;&#79;&#80;&#36;",
        reactComponent: <>&#77;&#79;&#80;&#36;</>
    },
    {
        code: "MRO",
        name: "Mauritanian ouguiya",
        symbol: "&#85;&#77;",
        reactComponent: <>&#85;&#77;</>
    },
    {
        code: "MUR",
        name: "Mauritian rupee",
        symbol: "&#8360;",
        reactComponent: <>&#8360;</>
    },
    {
        code: "MVR",
        name: "Maldivian rufiyaa",
        symbol: ".&#1923;",
        reactComponent: <>.&#1923;</>
    },
    {
        code: "MWK",
        name: "Malawian kwacha",
        symbol: "&#77;&#75;",
        reactComponent: <>&#77;&#75;</>
    },
    {
        code: "MXN",
        name: "Mexican peso",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "MYR",
        name: "Malaysian ringgit",
        symbol: "&#82;&#77;",
        reactComponent: <>&#82;&#77;</>
    },
    {
        code: "MZN",
        name: "Mozambican metical",
        symbol: "&#77;&#84;",
        reactComponent: <>&#77;&#84;</>
    },
    {
        code: "NAD",
        name: "Namibian dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "NGN",
        name: "Nigerian naira",
        symbol: "&#8358;",
        reactComponent: <>&#8358;</>
    },
    {
        code: "NIO",
        name: "Nicaraguan córdoba",
        symbol: "&#67;&#36;",
        reactComponent: <>&#67;&#36;</>
    },
    {
        code: "NOK",
        name: "Norwegian krone",
        symbol: "&#107;&#114;",
        reactComponent: <>&#107;&#114;</>
    },
    {
        code: "NPR",
        name: "Nepalese rupee",
        symbol: "&#8360;",
        reactComponent: <>&#8360;</>
    },
    {
        code: "NZD",
        name: "New Zealand dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "OMR",
        name: "Omani rial",
        symbol: "&#65020;",
        reactComponent: <>&#65020;</>
    },
    {
        code: "PAB",
        name: "Panamanian balboa",
        symbol: "&#66;&#47;&#46;",
        reactComponent: <>&#66;&#47;&#46;</>
    },
    {
        code: "PEN",
        name: "Peruvian nuevo sol",
        symbol: "&#83;&#47;&#46;",
        reactComponent: <>&#83;&#47;&#46;</>
    },
    {
        code: "PGK",
        name: "Papua New Guinean kina",
        symbol: "&#75;",
        reactComponent: <>&#75;</>
    },
    {
        code: "PHP",
        name: "Philippine peso",
        symbol: "&#8369;",
        reactComponent: <>&#8369;</>
    },
    {
        code: "PKR",
        name: "Pakistani rupee",
        symbol: "&#8360;",
        reactComponent: <>&#8360;</>
    },
    {
        code: "PLN",
        name: "Polish złoty",
        symbol: "&#122;&#322;",
        reactComponent: <>&#122;&#322;</>
    },
    {
        code: "PRB",
        name: "Transnistrian ruble",
        symbol: "PRB",
        reactComponent: <>PRB</>
    },
    {
        code: "PYG",
        name: "Paraguayan guaraní",
        symbol: "&#71;&#115;",
        reactComponent: <>&#71;&#115;</>
    },
    {
        code: "QAR",
        name: "Qatari riyal",
        symbol: "&#65020;",
        reactComponent: <>&#65020;</>
    },
    {
        code: "RON",
        name: "Romanian leu",
        symbol: "&#108;&#101;&#105;",
        reactComponent: <>&#108;&#101;&#105;</>
    },
    {
        code: "RSD",
        name: "Serbian dinar",
        symbol: "&#1044;&#1080;&#1085;&#46;",
        reactComponent: <>&#1044;&#1080;&#1085;&#46;</>
    },
    {
        code: "RUB",
        name: "Russian ruble",
        symbol: "&#8381;",
        reactComponent: <>&#8381;</>
    },
    {
        code: "RWF",
        name: "Rwandan franc",
        symbol: "&#1585;.&#1587;",
        reactComponent: <>&#1585;.&#1587;</>
    },
    {
        code: "SAR",
        name: "Saudi riyal",
        symbol: "&#65020;",
        reactComponent: <>&#65020;</>
    },
    {
        code: "SBD",
        name: "Solomon Islands dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "SCR",
        name: "Seychellois rupee",
        symbol: "&#8360;",
        reactComponent: <>&#8360;</>
    },
    {
        code: "SDG",
        name: "Singapore dollar",
        symbol: "&#163;",
        reactComponent: <>&#163;</>
    },
    {
        code: "SEK",
        name: "Swedish krona",
        symbol: "&#107;&#114;",
        reactComponent: <>&#107;&#114;</>
    },
    {
        code: "SGD",
        name: "Singapore dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "SHP",
        name: "Saint Helena pound",
        symbol: "&#163;",
        reactComponent: <>&#163;</>
    },
    {
        code: "SLL",
        name: "Sierra Leonean leone",
        symbol: "&#76;&#101;",
        reactComponent: <>&#76;&#101;</>
    },
    {
        code: "SOS",
        name: "Somali shilling",
        symbol: "&#83;",
        reactComponent: <>&#83;</>
    },
    {
        code: "SRD",
        name: "Surinamese dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "SSP",
        name: "South Sudanese pound",
        symbol: "SSP",
        reactComponent: <>SSP</>
    },
    {
        code: "STD",
        name: "São Tomé and Príncipe dobra",
        symbol: "&#68;&#98;",
        reactComponent: <>&#68;&#98;</>
    },
    {
        code: "SVC",
        name: "Salvadoran colón",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "SYP",
        name: "Syrian pound",
        symbol: "&#163;",
        reactComponent: <>&#163;</>
    },
    {
        code: "SZL",
        name: "Swazi lilangeni",
        symbol: "&#76;",
        reactComponent: <>&#76;</>
    },
    {
        code: "THB",
        name: "Thai baht",
        symbol: "&#3647;",
        reactComponent: <>&#3647;</>
    },
    {
        code: "TJS",
        name: "Tajikistani somoni",
        symbol: "&#84;&#74;&#83;",
        reactComponent: <>&#84;&#74;&#83;</>
    },
    {
        code: "TMT",
        name: "Turkmenistan manat",
        symbol: "&#109;",
        reactComponent: <>&#109;</>
    },
    {
        code: "TND",
        name: "Tunisian dinar",
        symbol: "&#1583;.&#1578;",
        reactComponent: <>&#1583;.&#1578;</>
    },
    {
        code: "TOP",
        name: "Tongan paʻanga",
        symbol: "&#84;&#36;",
        reactComponent: <>&#84;&#36;</>
    },
    {
        code: "TRY",
        name: "Turkish lira",
        symbol: "&#8356;",
        reactComponent: <>&#8356;</>
    },
    {
        code: "TTD",
        name: "Trinidad and Tobago dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "TWD",
        name: "New Taiwan dollar",
        symbol: "&#78;&#84;&#36;",
        reactComponent: <>&#78;&#84;&#36;</>
    },
    {
        code: "TZS",
        name: "Tanzanian shilling",
        symbol: "TZS",
        reactComponent: <>TZS</>
    },
    {
        code: "UAH",
        name: "Ukrainian hryvnia",
        symbol: "&#8372;",
        reactComponent: <>&#8372;</>
    },
    {
        code: "UGX",
        name: "Ugandan shilling",
        symbol: "&#85;&#83;&#104;",
        reactComponent: <>&#85;&#83;&#104;</>
    },
    {
        code: "UYU",
        name: "Uruguayan peso",
        symbol: "&#36;&#85;",
        reactComponent: <>&#36;&#85;</>
    },
    {
        code: "UZS",
        name: "Uzbekistani som",
        symbol: "&#1083;&#1074;",
        reactComponent: <>&#1083;&#1074;</>
    },
    {
        code: "VEF",
        name: "Venezuelan bolívar",
        symbol: "&#66;&#115;",
        reactComponent: <>&#66;&#115;</>
    },
    {
        code: "VND",
        name: "Vietnamese đồng",
        symbol: "&#8363;",
        reactComponent: <>&#8363;</>
    },
    {
        code: "VUV",
        name: "Vanuatu vatu",
        symbol: "&#86;&#84;",
        reactComponent: <>&#86;&#84;</>
    },
    {
        code: "WST",
        name: "Samoan tālā",
        symbol: "&#87;&#83;&#36;",
        reactComponent: <>&#87;&#83;&#36;</>
    },
    {
        code: "XAF",
        name: "Central African CFA franc",
        symbol: "&#70;&#67;&#70;&#65;",
        reactComponent: <>&#70;&#67;&#70;&#65;</>
    },
    {
        code: "XCD",
        name: "East Caribbean dollar",
        symbol: "&#36;",
        reactComponent: <>&#36;</>
    },
    {
        code: "XOF",
        name: "West African CFA franc",
        symbol: "XOF",
        reactComponent: <>XOF</>
    },
    {
        code: "XPF",
        name: "CFP franc",
        symbol: "&#70;",
        reactComponent: <>&#70;</>
    },
    {
        code: "YER",
        name: "Yemeni rial",
        symbol: "&#65020;",
        reactComponent: <>&#65020;</>
    },
    {
        code: "ZAR",
        name: "South African rand",
        symbol: "&#82;",
        reactComponent: <>&#82;</>
    },
    {
        code: "ZMW",
        name: "Zambian kwacha",
        symbol: "ZMW",
        reactComponent: <>ZMW</>
    },
    {
        code: "ZWL",
        name: "Zimbabwean dollar",
        symbol: "&#90;&#36;",
        reactComponent: <>&#90;&#36;</>
    }
]

export const CurrencySymbol = ({countryCode} : {countryCode:string}) : ReactElement => {
    // @ts-ignore
    return currencies.find((c: Currency) => c.code === countryCode.toUpperCase()).reactComponent;
}

